export function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                if (cookieValue.startsWith("\"") && cookieValue.endsWith("\""))
                    cookieValue = cookieValue.substring(1, cookieValue.length - 1);
                break;
            }
        }
    }

    return cookieValue;
}

export function getMeta(name) {
    const metas = document.getElementsByTagName('meta');

    for (const meta of metas) {
        if (meta.getAttribute('name') === name) {
            return meta.getAttribute('content');
        }
    }

    return '';
}

export function getTicketToken() {
    const params = new URLSearchParams(window.location.search);
    return params.get('token');
}
